module.exports = __webpack_public_path__ + "static/media/half.ba3b7e82.png";